import {I18nManager, Linking, Platform, Share} from "react-native";
import i18n from "../I18n/i18n";
import store from "../redux/store";
import {AsyngStorageClass} from "./AsyngStorageClass";
import Toast from "../customviews/toast";
import {serviceActionSetState} from "../screens/137/splash/action/ActionSplashGetAllData";
import * as NavigationService from "../redux/NavigationService";
import {typeExport} from "../redux/store/type";
import HMAlert from "../customviews/HMAlert";
import _G_ from './constant/_G_';

export function CheckNull(text) {
    return text.name === null ? text.name : (text.value === null ? text.value : text.title === null ? text.title : text)
}

/**
 * @return {null}
 */
export function CheckValue(text, type) {
    // if (type && text && text.length > 0)
    //     text = text.trim()

    if (!text || text === null || text === "null" || text === undefined || text === "undefined" || text === "" || text === " " || text.length === 0)
        return null
    else
        return text.id ? (text.id != '0' ? text.id : null) : CheckNull(text)
    //  return text
}

export function numberWithCommas(x) {
    if (x === null || x === "null" || x === '' || x === undefined)
        return '';

    x = x.toString().replace(/,/g, '');
    x = x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return x;

    //return x;
}


export function GoLink(url, type) {
    if (type === 'phone') {
        url = Platform.OS === 'ios' ? `telprompt:${url}` : `tel://${url}`;
        Linking.canOpenURL(url)
            .then((supported) => {
                if (supported) {
                    return Linking.openURL(url)
                        .catch(() => null);
                }
            });
    }

    // return Linking.openURL(url).catch(err => console.error('An error occurred', err))
    else {
        if (Platform.OS == 'web') {
            // return window.open(url, '_blank');
            // return        window.location.assign(url);
            //  return        window.history.replaceState( {} , "hi", url );
            //  return <Redirect to={url}>Go to Jane's profile</Redirect>;

            if (type === 'self')
                return window.location.href = url;
            else
                return window.open(url, '_blank');
            // return      window.location = url;
            //return     window.navigate("https://www.google.com/");

            // return         window.open(url,'_self');


            //  var importantStuff = window.open(url, '_blank');
            //  importantStuff.document.write('لطفا صبر نمایید ...');
            //  importantStuff.location.href = url;
            //importantStuff.close();


        } else {
            return Linking.openURL(url).catch(err => console.error('An error occurred', err))
        }
    }
}

export function DeviceInfo(formData) {
    // let DeviceInfo = null;
    // if (Platform.OS != "web")
    //     DeviceInfo = require("react-native-device-info")
    formData.append('lang', i18n.locale);
    formData.append('platform', Platform.OS);
    formData.append('token_fb', store.getState().reducerSplashSatiaScreen.token_fb);
    formData.append('platform', Platform.OS);
    formData.append('userAgentData', Platform.OS === "web" ? navigator.userAgentData?.mobile : false);
    // formData.append('userAgentData', true);

    if (formData && Platform.OS !== "web") {
        /*            let getUniqueId = DeviceInfo.getUniqueId();

                    if (Clipboard)
                        Clipboard.setString(getUniqueId)*/
        let DeviceInfo = require("../importCalss/DeviceInfo").default;
        formData.append('BuildNumber', Platform.OS === 'ios' ? DeviceInfo.getBuildNumber() : DeviceInfo.getVersion());

        formData.append('UniqueId', DeviceInfo.getUniqueId());
    }
}


export function addAllFormData(formData, checkCity, typeRequest) {
    let {Location, City, TypeLogin, OrganCity, user} = store.getState().reducerSplashGetAllData;

    City = (typeRequest === "City") ? City : OrganCity;
    formData.append('tenant_id', City && (checkCity || (user && user.orgs)) ? City.tenant_id : 0);
    // formData.append('platform', Platform.OS);


    const latitude = Platform.OS === "web" ? formData.get('latitude') : formData.getParts().find(item => item.fieldName === 'latitude');
    if (latitude) {
        // const value = latitude.string;
    }
    // if (formData.get('latitude')) {
    // }
    else {

        formData.append('latitude', Location?.coords.latitude);
        formData.append('longitude', Location?.coords.longitude);
    }

}


export async function changeAppLang(lang, type) {
    //i18n.locale = 'fa';
    if (lang != 'en') {
        if (!I18nManager.getConstants().isRTL) {
            await I18nManager.forceRTL(true);
        }
    } else {
        if (I18nManager.getConstants().isRTL) {
            await I18nManager.forceRTL(false);
        }
    }
    await AsyngStorageClass.setLang(lang);


    if (Platform.OS !== "web") {
        let RNRestart = require("react-native-restart").default;
        RNRestart.Restart()
    }

    else {
        await I18nManager.forceRTL(lang == 'fa');
      //  document.documentElement.setAttribute('dir',lang == 'fa' ? 'rtl' : 'ltr')
        //  document.documentElement.setAttribute('dir', 'rtl');
        // document.documentElement.setAttribute('dir', 'ltr');
        window.location.reload();
    }
}

/**
 * @return {null}
 */
export function BackgroundImage(image) {
    if (image && image != null)
        return image
    // return require(`${image}`)
    //   return require(image)
    else
        return null


}

export function copyClipboardWeb(text) {
    if (navigator.clipboard) {

        navigator.clipboard.writeText(text).then(function () {
            console.log('Copied to clipboard successfully!');
            Toast.show({
                // type: 'success | error | info',
                type: 'custom_info',
                //  type: data.status ? 'custom_success' : 'custom_error',
                //  position: 'top | bottom',
                position: 'top',
                text1: i18n.t('constant.message'),
                text2: "لینک کپی شد" + "\n" + text,
                visibilityTime: 5000,
                autoHide: true,
                //  topOffset: 30,
                // bottomOffset: 40,
                onShow: () => {
                },
                onHide: () => {
                }
            })
        }, function () {
            console.error('Unable to write to clipboard. :-(');

            const textArea = document.createElement("textarea");
            textArea.value = text;
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            try {
                document.execCommand('copy');
                Toast.show({
                    // type: 'success | error | info',
                    type: 'custom_info',
                    //  type: data.status ? 'custom_success' : 'custom_error',
                    //  position: 'top | bottom',
                    position: 'top',
                    text1: i18n.t('constant.message'),
                    text2: "لینک کپی شد" + "\n" + text,
                    visibilityTime: 5000,
                    autoHide: true,
                    //  topOffset: 30,
                    // bottomOffset: 40,
                    onShow: () => {
                    },
                    onHide: () => {
                    }
                })
            } catch (err) {
                console.error('Unable to copy to clipboard', err);
            }
            document.body.removeChild(textArea);
        });
    }
}

export function onShare(item) {
    let data = null;
    //if (typeExport._NameApp === "Satia")
    //  data = store.getState().reducerSplashSatiaScreen && store.getState().reducerSplashSatiaScreen.results && store.getState().reducerSplashSatiaScreen.results.info;

    let store_data = store.getState().reducerSplashGetAllData;
    let checkLoginCloud = (store_data.TypeLogin == 2)
    let DataSplashScreenSaina = checkLoginCloud ? (store_data.resultsShahrdar ? store_data.resultsShahrdar.result : null) : (store_data.resultsSaina ? store_data.resultsSaina.result : null)
    data = DataSplashScreenSaina?.info
    // else
    //     data = store.getState().reducerSplashGetAllData.resultsSaina.result.info;


    let url = item && item.link_url ? item.link_url : (Platform.OS === "ios" ? data.ios.link : data.android.link);
    let message = item && item.description ? item.description + "\n" + (item.link_url ? item.link_url : "") : (Platform.OS === "ios" ? data.description + "\n" + data.ios.link : data.description + "\n" + data.android.link);

    if (Platform.OS === "web") {
        if (navigator.share) {
            navigator.share({
                //title: 'web.dev',
                title: 'معرفی به دوستان',
                text: message,
                url: url,
            })
                .then(() => console.log('Successful share'))
                .catch((error) => console.log('Error sharing', error));
        }
        else {
            copyClipboardWeb(url)
            // navigator.clipboard.writeText(url)
            // Toast.show({
            //     // type: 'success | error | info',
            //     type: 'custom_info',
            //     //  type: data.status ? 'custom_success' : 'custom_error',
            //     //  position: 'top | bottom',
            //     position: 'top',
            //     text1: i18n.t('constant.message'),
            //     text2: "لینک کپی شد",
            //     visibilityTime: 4000,
            //     autoHide: true,
            //     //  topOffset: 30,
            //     // bottomOffset: 40,
            //     onShow: () => {
            //     },
            //     onHide: () => {
            //     }
            // })
        }

    }


    else {
        // console.log("Share was ", message, url)
        Share
            .share(
                {
                    message: message,
                    url: url,
                }
            )

            .then(
                ({action, activityType}) => {
                    if (action === Share.sharedAction)
                        console.log('Share was successful');
                    else
                        console.log('Share was dismissed');
                }
            )
        ;
    }


}

export function selectMenu(item) {
    global.typeCategory = item.type;
    switch (parseFloat(item.type)) {

        case 0 :
            /*      if (item.id == 71) {
                      NavigationService.navigateParams("RegisterComplaintsScreen", {item})

                  } else*/
            //    Tools.GoLink(item.link_url)
            if (store.getState().reducerSplashGetAllData.Connection) {

                // if (item.id == 123)
                //     NavigationService.navigateParams("AdvancedSearchScreen", {item})
                //   // NavigationService.navigateParams("GraveyardScreen", {item})
                // else

                if (item.login && !store.getState().reducerSplashGetAllData.token) {

                    store.dispatch(serviceActionSetState({
                        type: "WebViewScreen",
                        //   type: "InformationFanoosScreen",
                        item: item
                    }))
                    NavigationService.navigateParams('LoginStackScreen')
                }
                else {
                    // alert("bbbb")

                    NavigationService.navigateParams("WebViewScreen", {item: JSON.stringify(item)})
                    //NavigationService.navigateParams("InformationFanoosScreen", {item})

                }
            }
            else {
                // alert("fgfg")
                //ParentScreen.ShowMessageBack(i18n.t('constant.CheckYourInternet'))
            }
            break;


        case 1 :
            //  NavigationService.navigateParams("ListNewsScreen", {item: item,link_url:item.link_url,link_type:item.link_type,id:item.id,name:item.name})
            NavigationService.navigateParams("ListNewsScreen", {
                item: JSON.stringify(item),

            })

            //   this.props.navigation.navigate("ListNewsScreen", {item})
            break;


        case 2 :
            GoLink(item.link_url)

            break;


        case 3 :
            NavigationService.navigateParams("CategoryScreen", {item: JSON.stringify(item)})

            break;


        case 4 :

            break;


        case 5 :
            let check = false;
            //let check = (typeExport._NameApp === "Cloud" || typeExport._NameApp === "CloudTest") && (!Tools.CheckValue(this.props.DataSplashScreen.TypeLogin) || this.props.DataSplashScreen.TypeLogin == 1);

            if ((typeExport._NameApp === "Cloud" || typeExport._NameApp === "CloudTest")) {
                NavigationService.navigateParams("ApplyParentScreen", {item: JSON.stringify(item), type: "request"})
            }
            else if (store.getState().reducerSplashGetAllData.token != null) {

                NavigationService.navigateParams(check ? "ApplyParentScreen" : "ApplyScreen", {item: JSON.stringify(item),})

                // NavigationService.navigateParams("ManInjamScreen", {item,})

            } else {
                store.dispatch(serviceActionSetState({
                    type: check ? "ApplyParentScreen" : "ApplyScreen",
                    item: JSON.stringify(item)
                }))
                NavigationService.navigateParams('LoginStackScreen')

            }


            break;


        case 6 :
            NavigationService.navigateParams("ShowMap", {myLocation: true, item: item})

            // this.setState({isLoading: true, index: key}, () => {
            //     Tools.checkPermission(
            //         "ShowMap",
            //         item,
            //         key,
            //         this.goScreen,
            //         this.stateError
            //     )
            // })

            break;
        //competition
        case  7 :
            //  if (this.props.DataSplashScreen.TypeLogin == 1 || this.props.DataSplashScreen.TypeLogin == null || !this.props.DataSplashScreen.token)

            if ((typeExport._NameApp === "Cloud" || typeExport._NameApp === "CloudTest")) {
                NavigationService.navigateParams("ApplyParentScreen", {item: JSON.stringify(item), type: "result"})
            }
            else
                NavigationService.navigateParams("ApplyScreen", {item: JSON.stringify(item)})

            // else
            //     Toast.show({
            //         // type: 'success | error | info',
            //         type: 'custom_info',
            //         //  type: data.status ? 'custom_success' : 'custom_error',
            //         //  position: 'top | bottom',
            //         position: 'top',
            //         text1: i18n.t('constant.message'),
            //         text2: "شما به سامانه ۱۸۸۸ دسترسی ندارید ",
            //         visibilityTime: 4000,
            //         autoHide: true,
            //         //  topOffset: 30,
            //         // bottomOffset: 40,
            //         onShow: () => {
            //         },
            //         onHide: () => {
            //         }
            //     })

            break;

        case  8 :
            NavigationService.navigateParams("AdvancedSearchScreen", {item})
            break;

        case  9 :
            if (!store.getState().reducerSplashGetAllData.token) {
                store.dispatch(serviceActionSetState({
                    type: "CompetitionScreen",
                    //   type: "InformationFanoosScreen",
                    item: item
                }))
                NavigationService.navigateParams('LoginStackScreen')
            }
            else {
                NavigationService.navigateParams("CompetitionScreen", {
                    item,
                    type: "CompetitionScreen"
                });
            }

            break;
        case  11 :
            if (!store.getState().reducerSplashGetAllData.token) {
                store.dispatch(serviceActionSetState({
                    type: "GalleryServiceScreen",
                    //   type: "InformationFanoosScreen",
                    item: item
                }))
                NavigationService.navigateParams('LoginStackScreen')
            }
            else {
                NavigationService.navigateParams("GalleryServiceScreen", {
                    item,
                    type: "GalleryServiceScreen"
                });
            }

            break;

        case  "satia1" :
            NavigationService.navigateParams("AdvancedSearchScreen", {item})
            break;
        case  "satia2" :
            NavigationService.navigateParams("AdvancedSearchScreen", {item})
            break;
        case  "satia3" :
            NavigationService.navigateParams("AdvancedSearchScreen", {item})
            break;
        case  "satia4" :
            NavigationService.navigateParams("AdvancedSearchScreen", {item})
            break;


        case  999 :
            if (store.getState().reducerSplashGetAllData.token != null) {

                if ((store.getState().reducerSplashGetAllData.TypeLogin == 1)) {
                    HMAlert(
                        i18n.t('constant.message'),
                        "شما به این قسمت دسترسی ندارید",
                        [

                            item ? {
                                text: i18n.t('constant.ok'),
                                onPress: () => {
                                },
                                style: 'cancel'
                            } : {},


                        ],
                        {cancelable: true}
                    )
                }
                else
                    NavigationService.navigateParams("ApplyScreen", {item: JSON.stringify(item),})

                // NavigationService.navigateParams("ManInjamScreen", {item,})

            } else {
                store.dispatch(serviceActionSetState({
                    type: "ApplyScreen",
                    item: JSON.stringify(item)
                }))
                NavigationService.navigateParams('LoginStackScreen')

            }
            break;

        default:
            alert("")

    }
}


export function exitApp() {
    HMAlert(
        i18n.t('constant.message'),
        i18n.t('constant.WantToLogOut'),
        [
            // {text: 'Ask me later', onPress: () => {}},
            {
                text: i18n.t('constant.No'), onPress: () => {
                }, style: 'cancel'
            },
            {
                text: i18n.t('constant.Yes'), onPress: () => {
                    //  this.remove()
                    AsyngStorageClass.removeToken();

                    //    NavigationService.resetTo("Drawer")

                    if (typeExport._TypeApp === "Satia") {
                        NavigationService.resetTo('LoginStackScreen')

                    }
                    else
                        NavigationService.PopToPop()

                    //, NavigationService.resetTo('SplashScreen')
                }
            },
        ],
        {cancelable: true}
    )

}

export function GoLink_AI(link_ios, link_android) {
    return Linking.openURL(Platform.OS === "ios" ? link_ios : link_android).catch(err => console.error('An error occurred', err))
}

export function getSizeByte(bytes, flag) {

    bytes = bytes.size;
    if (flag) {
        if (bytes < 1024) return (bytes + " Bytes");
        else if (bytes < 1048576) return (bytes / 1024).toFixed(0) + " KB";
        else if (bytes < 1073741824) return (bytes / 1048576).toFixed(0) + " MB";
        else return (bytes / 1073741824).toFixed(0) + " GB";
    }
    else {

    }


}
